import request from '@/utils/request'

//转账记录
export function withdrawTransferList(data) {
    return request({
      url: '/admin/withdrawTransferBnb/list',
      method: 'post',
      data: data
    })
  }
  export function totalRecharge(data) {
    return request({
      url: '/admin/tronscanTransfer/totalRecharge',
      method: 'post',
      data: data
    })
  }
  export function tronscanTransferList(data) {
    return request({
      url: '/admin/tronscanTransfer/list',
      method: 'post',
      data: data
    })
  }
  export function verifyPassword(data) {
    return request({
      url: '/admin/bnbMasterAccount/verifyPassword',
      method: 'post',
      data: data
    })
  }
// 归集账号管理
export function bnbMasterAccountList(data) {
  return request({
    url: '/admin/bnbMasterAccount/list',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountDelete(data) {
  return request({
    url: '/admin/bnbMasterAccount/delete',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountSave(data) {
  return request({
    url: '/admin/bnbMasterAccount/save',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountUpdate(data) {
  return request({
    url: '/admin/bnbMasterAccount/update',
    method: 'post',
    data: data
  })
}
export function getById(data) {
  return request({
    url: '/admin/bnbMasterAccount/getById',
    method: 'post',
    data: data
  })
}
export function genNew(data) {
  return request({
    url: '/admin/bnbMasterAccount/genNew',
    method: 'post',
    data: data
  })
}
export function importWallet(data) {
  return request({
    url: '/admin/bnbMasterAccount/importWallet',
    method: 'post',
    data: data
  })
}

// 归集记录
export function tronscanCollectionList(data) {
    return request({
      url: '/admin/bnbCollectionUsdt/list',
      method: 'post',
      data: data
    })
  }
  export function totalAmount(data) {
    return request({
      url: '/admin/bnbCollectionUsdt/totalAmount',
      method: 'post',
      data: data
    })
  }
// trx归集记录
export function tronscanCollectionListTrx(data) {
  return request({
    url: '/admin/bnbCollectionTrx/list',
    method: 'post',
    data: data
  })
}
export function totalAmountTrx(data) {
  return request({
    url: '/admin/bnbCollectionTrx/totalAmount',
    method: 'post',
    data: data
  })
}
// 提现转账
export function withdrawTransfer(data) {
    return request({
      url: '/admin/withdrawTransferBnb/list',
      method: 'post',
      data: data
    })
  }
  export function autoZhuan(data) {
    return request({
      url: '/admin/withdrawTransferBnb/autoZhuan',
      method: 'post',
      data: data
    })
  }
  export function updateAutoZhuan(data) {
    return request({
      url: '/admin/withdrawTransferBnb/updateAutoZhuan',
      method: 'post',
      data: data
    })
  }
  export function zhuan(data) {
    return request({
      url: '/admin/withdrawTransferBnb/zhuan',
      method: 'post',
      data: data
    })
  }
  export function reject(data) {
    return request({
      url: '/admin/withdrawTransferBnb/reject',
      method: 'post',
      data: data
    })
  }
  export function zhuanList(data) {
    return request({
      url: '/admin/withdrawTransferBnb/zhuanList',
      method: 'post',
      data: data
    })
  }
  export function masterAccounts(data) {
    return request({
      url: '/admin/withdrawTransferBnb/masterAccounts',
      method: 'post',
      data: data
    })
  }
  export function applyCount(data) {
    return request({
      url: '/admin/withdrawTransferBnb/applyCount',
      method: 'post',
      data: data
    })
  }
  // 用户资金管理
  export function masterAccountsT(data) {
    return request({
      url: '/admin/memberCollectionBnb/masterAccounts',
      method: 'post',
      data: data
    })
  }
  export function collectBnb(data) {
    return request({
      url: '/admin/memberCollectionBnb/collectBnb',
      method: 'post',
      data: data
    })
  }
  export function collect(data) {
    return request({
      url: '/admin/memberCollectionBnb/collect',
      method: 'post',
      data: data
    })
  }
  export function zhuanBnb(data) {
    return request({
      url: '/admin/memberCollectionBnb/zhuanBnb',
      method: 'post',
      data: data
    })
  }
  export function collectTrx(data) {
    return request({
      url: '/admin/memberCollectionBnb/collectTrx',
      method: 'post',
      data: data
    })
  }
  export function delegatedEnergy(data) {
    return request({
      url: '/admin/memberCollectionBnb/delegatedEnergy',
      method: 'post',
      data: data
    })
  }
  export function undelegateResource(data) {
    return request({
      url: '/admin/memberCollectionBnb/undelegateResource',
      method: 'post',
      data: data
    })
  }
  export function oneCollect(data) {
    return request({
      url: '/admin/memberCollectionBnb/oneCollect',
      method: 'post',
      data: data
    })
  }
  export function collectView(data) {
    return request({
      url: '/admin/memberCollectionBnb/collectView',
      method: 'post',
      data: data
    })
  }
  export function collectList(data) {
    return request({
      url: '/admin/memberCollectionBnb/collectList',
      method: 'post',
      data: data
    })
  }
  export function collectListRemove(data) {
    return request({
      url: '/admin/memberCollectionBnb/collectListRemove',
      method: 'post',
      data: data
    })
  }
  export function memberCollectionList(data) {
    return request({
      url: '/admin/memberCollectionBnb/list',
      method: 'post',
      data: data
    })
  }



  export function memberPayAdList(data) {
    return request({
      url: '/admin/memberPayAd/list',
      method: 'post',
      data: data
    })
  }
  export function memberPayAdPass(data) {
    return request({
      url: '/admin/memberPayAd/pass',
      method: 'post',
      data: data
    })
  }
  export function memberPayAdReject(data) {
    return request({
      url: '/admin/memberPayAd/reject',
      method: 'post',
      data: data
    })
  }
  export function withdrawTransferTotalAmount(data) {
    return request({
      url: '/admin/withdrawTransferBnb/totalAmount',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanTotalAmount(data) {
    return request({
      url: '/admin/bnbZhuanUsdt/totalAmount',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanList(data) {
    return request({
      url: '/admin/bnbZhuanUsdt/list',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanExport(data) {
    return request({
      url: '/admin/bnbZhuanUsdt/export',
      method: 'post',
      data: data
    })
  }
  export function batchFreshUSDT(data) {
    return request({
      url: '/admin/memberCollectionBnb/batchFreshAsset',
      method: 'post',
      data
    })
  }
  export function resetFreshStatus(data) {
    return request({
      url: '/admin/memberCollectionBnb/resetFreshStatus',
      method: 'post',
      data
    })
  }
  export function batchFreshAssetUSDT(data) {
    return request({
      url: '/admin/memberCollectionBnb/batchFreshAssetUSDT',
      method: 'post',
      data
    })
  }
  export function batchFreshAssetBNB(data) {
    return request({
      url: '/admin/memberCollectionBnb/batchFreshAssetBNB',
      method: 'post',
      data
    })
  }
  export function withdrawTransferBnbResetStatus(data) {
    return request({
      url: '/admin/withdrawTransferBnb/resetStatus',
      method: 'post',
      data
    })
  }
  export function resetStatus(data) {
    return request({
      url: '/admin/memberCollectionBnb/resetStatus',
      method: 'post',
      data
    })
  }
  export function freshUSDT(data) {
    return request({
      url: '/admin/memberCollectionBnb/freshAsset',
      method: 'post',
      data
    }) 
  }
  // TRX提现转账
  export function listTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/list',
      method: 'post',
      data
    })
  }
  export function totalAmountTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/totalAmount',
      method: 'post',
      data
    })
  }
  export function applyCountTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/applyCount',
      method: 'post',
      data
    })
  }
  export function updateAutoZhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/updateAutoZhuan',
      method: 'post',
      data
    })
  }
  export function zhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/zhuan',
      method: 'post',
      data
    })
  }
  export function rejectTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/reject',
      method: 'post',
      data
    })
  }
  export function zhuanListTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/zhuanList',
      method: 'post',
      data
    })
  }
  export function masterAccountsTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/masterAccounts',
      method: 'post',
      data
    })
  }
  export function autoZhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/autoZhuan',
      method: 'post',
      data
    })
  }
  // TRX转账记录
  export function tronscanZhuanWithdrawTrxList(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/list',
      method: 'post',
      data
    })
  }
  export function tronscanZhuanWithdrawTrxTotalAmount(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/totalAmount',
      method: 'post',
      data
    })
  }
  export function tronscanZhuanWithdrawTrxExport(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/export',
      method: 'post',
      data
    })
  }
  // 其他币种归集记录
  export function bnbCollectionOtherList(data) {
    return request({
      url: '/admin/bnbCollectionOther/list',
      method: 'post',
      data
    })
  }
  export function bnbCollectionOtherTotalAmount(data) {
    return request({
      url: '/admin/bnbCollectionOther/totalAmount',
      method: 'post',
      data
    })
  }
  export function collectOther(data) {
    return request({
      url: '/admin/memberCollectionBnb/collectOther',
      method: 'post',
      data
    })
  }
  export function batchFreshAssetOther(data) {
    return request({
      url: '/admin/memberCollectionBnb/batchFreshAssetOther',
      method: 'post',
      data
    })
  }
  export function freshAssetOther(data) {
    return request({
      url: '/admin/memberCollectionBnb/freshAssetOther',
      method: 'post',
      data
    })
  }
